import styled from 'styled-components';

export const FactContainer = styled.div.attrs({
  className: 'FactContainer',
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SummaryContainer = styled.div.attrs({
  className: 'SummaryContainer',
})`
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  height: 100%;
  gap: 3px;
  border-radius: 5px;
  margin: 0 10px;
  padding: 8px 0;
  box-sizing: border-box;
  justify-content: space-between;
`;
